import { withStyles } from "@material-ui/core/styles";
import { ErrorRounded } from "@material-ui/icons";
import StyledToolTip from "../../../../common/StyledToolTip";
import appConstants from "../../../../../appConstants";
const styles = (theme) => ({
  severityHigh: {
    color: theme.error,
    fontSize: "20px",
  },
  severityLow: {
    color: theme.warningColor,
    fontSize: "20px",
  },
  severityIcon: {
    paddingRight: 4,
  },
  container: {
    display: "flex",
    alignItems: "center",
  },
  comments: {
    whiteSpace: "nowrap",
    width: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
});
const DefectsDetails = ({ data: { defects }, classes, value }) => {
  const severity = defects?.some(
    (defect) => defect.severity == appConstants.DEFECTS_SEVERITY_TYPES.H
  );
  const comments = value || null;
  return comments ? (
    <StyledToolTip title={comments}>
      <div className={classes.container}>
        <ErrorRounded
          className={`${classes.severityIcon} ${
            severity ? classes.severityHigh : classes.severityLow
          }`}
        />
        <span className={classes.comments}>{comments}</span>
      </div>
    </StyledToolTip>
  ) : null;
};
export default withStyles(styles)(DefectsDetails);
